'use client'

import { cn } from '@/core/lib/utils/cn'
import { FaqModel } from '@/features/content/types/models/faq.model'
import { Accordion, AccordionItem } from '../atoms/accordion'

type Props = {
  faqs: FaqModel[]
  className?: string
  headClassName?: string
}

export const FaqsList: React.FC<Props> = ({
  faqs,
  className = '',
  headClassName = '',
}) => {
  if (!faqs?.length) {
    return null
  }
  return (
    <Accordion defaultExpandedKeys={[0]} className={className}>
      {faqs.map((faq, index) => (
        <AccordionItem
          key={index + 1}
          aria-label={faq.question}
          title={faq.question}
          classNames={{
            heading: cn('text-navy', headClassName),
            base: 'text-navy',
          }}
        >
          <div
            className='text-navy'
            dangerouslySetInnerHTML={{
              __html: faq.answer,
            }}
          />
        </AccordionItem>
      ))}
    </Accordion>
  )
}
